import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Backend XHR (sem withFetch()): o FetchBackend do Angular chama aborter.abort()
    // incondicionalmente no teardown, mesmo após a resposta já ter sido lida por completo —
    // isso faz o Chrome descartar o corpo da resposta em erros no DevTools (Network > Response).
    // Bug conhecido e sem correção: https://github.com/angular/angular/issues/51054.
    provideHttpClient()
  ]
};
